var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ui-modal", {
        staticClass: "modal-vm18",
        attrs: { shown: _vm.showModal, id: "modal-vm18", "no-close": "" },
        scopedSlots: _vm._u(
          [
            {
              key: "header",
              fn: function () {
                return [
                  _vm._t("header", function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column justify-content-center align-items-center text-center container",
                        },
                        [
                          _vm.isVivaincontri
                            ? _c("svg-vm18-vivaincontri")
                            : _c("svg-vm18-skokka"),
                          _vm._v(" "),
                          _c(
                            "h2",
                            {
                              staticClass:
                                "text-center font-weight-bolder text-2xl mt-3",
                              attrs: { id: "modal-vm18__title" },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.i18n.pleaseRead) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "body",
              fn: function () {
                return [
                  _vm._t("body", function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "container d-flex flex-column  justify-content-center align-items-center",
                        },
                        [
                          _c("p", {
                            staticClass: "text-center max-w-320",
                            attrs: { id: "modal-vm18__text" },
                            domProps: {
                              innerHTML: _vm._s(_vm.i18n.eighteenYearOld),
                            },
                          }),
                          _vm._v(" "),
                          _c("hr", { staticClass: "my-1 border-0" }),
                          _vm._v(" "),
                          _c("p", {
                            staticClass: "text-center m-0 p-0",
                            attrs: { id: "modal-vm18__terms-and-conditions" },
                            domProps: {
                              textContent: _vm._s(_vm.i18n.termsAndConditions),
                            },
                          }),
                          _vm._v(" "),
                          _c("ui-button", {
                            staticClass: "m-0 p-0",
                            attrs: {
                              href: _vm.tcUrl,
                              "data-hreh": _vm.tcUrl,
                              "button-type": "blank",
                              "normal-case": "",
                              "no-box-shadow": "",
                              label: _vm.i18n.tac,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "footer",
              fn: function () {
                return [
                  _vm._t("footer", function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "container d-flex flex-column justify-content-center align-items-center",
                        },
                        [
                          _c("ui-button", {
                            staticClass: "m-0",
                            attrs: {
                              appearance: "primary",
                              label: _vm.i18n.accept,
                            },
                            on: { click: _vm.accept },
                          }),
                          _vm._v(" "),
                          _c("ui-button", {
                            staticClass: "m-0",
                            attrs: {
                              href: "https://www.google.com",
                              rel: "noopener nofollow",
                              "button-type": "blank",
                              "normal-case": "",
                              "no-box-shadow": "",
                              label: _vm.i18n.refuse,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }